import { Component, effect, inject } from '@angular/core';
import { Router } from '@angular/router';

import { SessionVariable } from '../../enum/session-variable';
import { TranslationService } from '../../services/translation.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { SharedSignalsService } from '../../services/shared-signals.service';
import { CheckoutService } from '../../../checkout/services/checkout.service';

@Component({
  selector: 'taly-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent {
  textDirection: string;
  showHeader: boolean = false;
  showBackBtn: boolean = true;

  private readonly storageService = inject(LocalStorageService);
  private readonly signalsService = inject(SharedSignalsService);
  private readonly translationService = inject(TranslationService);
  private readonly checkoutService = inject(CheckoutService);
  private readonly router = inject(Router);

  private toggleCurrentLanguage: boolean = false;

  constructor() {
    effect(() => {
      this.toggleCurrentLanguage =
        this.storageService.getItem(SessionVariable.LANGUAGE) === 'ar-KW';
      this.showHeader = this.signalsService?.showHeader();
      this.showBackBtn = this.signalsService?.showBackBtn();
      this.textDirection = this.signalsService?.textDirection();
    });
  }

  toggleText() {
    this.toggleCurrentLanguage = !this.toggleCurrentLanguage;

    const currentLanguage = this.toggleCurrentLanguage ? 'ar-KW' : 'en-US';
    const apiLanguage = this.toggleCurrentLanguage ? 'AR' : 'EN';

    const hasToken = !!this.storageService.getItem(SessionVariable.ACCESS_TOKEN);

    const isStandalone = this.router.url.includes('/standalone/');

    if (hasToken && !isStandalone) {
      this.checkoutService.changeLanguage(apiLanguage).subscribe({
        next: () => {
          this.changeLanguageState(currentLanguage);
        },
        error: (error) => {
          console.error('Failed to change language preference', error);

          this.toggleCurrentLanguage = !this.toggleCurrentLanguage;
        },
      });
    } else {
      this.changeLanguageState(currentLanguage);
    }
  }

  private changeLanguageState(currentLanguage: string) {
    this.storageService.setItem(SessionVariable.LANGUAGE, currentLanguage);
    this.signalsService.setTextDirection(currentLanguage === 'ar-KW' ? 'rtl' : 'ltr');
    this.translationService.switchLanguage(currentLanguage);
  }

  redirectBack() {
    this.signalsService.setShowCancelOrderPopup(true);
  }
}
